import { render, staticRenderFns } from "./C-2-2-2__SubCategoryEdit_Filter.vue?vue&type=template&id=651f5fc2&"
import script from "./C-2-2-2__SubCategoryEdit_Filter.vue?vue&type=script&lang=js&"
export * from "./C-2-2-2__SubCategoryEdit_Filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
